type WsClientHandle = { terminate: () => void };

let handle: WsClientHandle | null = null;

export function registerWsClient(client: WsClientHandle | null): void {
  handle = client;
}

export function reconnectWsClient(): void {
  handle?.terminate();
}
